import { ModalComponent } from '../../../../components/building-blocks/modal/modal';
import modalStyles from '../../../../components/building-blocks/modal/modal.module.scss';
import { TrafficInfoResponseAreaInfo } from '../../traffic-info-types';
import { cleanupHtmlBody } from '../../traffic-info-utils';
import styles from './traffic-info-area-modal.module.scss';

export interface TrafficInfoAreaModalProps {
  open: boolean;
  onClose: () => void;
  info?: TrafficInfoResponseAreaInfo;
}

export const TrafficInfoAreaModal = ({ open, onClose, info }: TrafficInfoAreaModalProps): JSX.Element => {
  const body = info ? cleanupHtmlBody(info.descriptionHtml) : '';

  return (
    <ModalComponent
      open={open}
      type="warning"
      onClose={onClose}
      headline={info ? <h2 className={modalStyles.Headline}>{info.title}</h2> : undefined}
      text={info ? <div className={styles.Text} dangerouslySetInnerHTML={{ __html: body }} /> : undefined}
    />
  );
};
